<app-generic-modal [isOpen]="isOpen" [config]="modalConfig" (closeModal)="onCloseModal()">

  <div class="user-detail-content">
    <!-- User Profile Section -->
    <div class="user-profile-section">
      <div class="user-avatar-large" [style.background-color]="getDefaultUserData().avatarColor">
        {{ getDefaultUserData().initials }}
      </div>
      <div class="user-basic-info">
        <h3>{{ userData?.displayName || getDefaultUserData().name }}</h3>
        <p class="user-email">{{ getDefaultUserData().email }}</p>
        <div class="user-status-section">
          <span class="status-badge" [class]="getStatusClass(userData?.status)">
            {{ getStatusLabel(userData?.status) }}
          </span>
        </div>
      </div>
    </div>

    <!-- User Details Grid -->
    <div class="user-details-grid">
      <div class="detail-item">
        <span class="detail-label">Created Date</span>
        <span>{{ getDefaultUserData().joinedDate }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">Terms & Conditions Accepted</span>
        <span>{{ getDefaultUserData().termsAccepted ? 'Yes' : 'No' }}</span>
      </div>
    </div>

    <!-- Page Access Permissions Section -->
    @if (editableAuthorizations) {
    <div class="permissions-section">
      <h4>Page Access Permissions</h4>
      <div class="permissions-grid">
        <div class="permission-column">
          <label class="permission-item">
            <input type="checkbox" 
                   [(ngModel)]="editableAuthorizations.entities"
                   (change)="onPermissionChange()">
            <span class="checkmark"></span>
            Entities
          </label>
          <label class="permission-item">
            <input type="checkbox" 
                   [(ngModel)]="editableAuthorizations.invoices"
                   (change)="onPermissionChange()">
            <span class="checkmark"></span>
            Invoices
          </label>
          <label class="permission-item">
            <input type="checkbox" 
                   [(ngModel)]="editableAuthorizations.assets"
                   (change)="onPermissionChange()">
            <span class="checkmark"></span>
            Assets
          </label>
          <label class="permission-item">
            <input type="checkbox" 
                   [(ngModel)]="editableAuthorizations.messages"
                   (change)="onPermissionChange()">
            <span class="checkmark"></span>
            Messages
          </label>
          <label class="permission-item">
            <input type="checkbox" 
                   [(ngModel)]="editableAuthorizations.shares"
                   (change)="onPermissionChange()">
            <span class="checkmark"></span>
            Shares
          </label>
        </div>
        <div class="permission-column">
          <label class="permission-item">
            <input type="checkbox" 
                   [(ngModel)]="editableAuthorizations.information"
                   (change)="onPermissionChange()">
            <span class="checkmark"></span>
            Information
          </label>
          <label class="permission-item">
            <input type="checkbox" 
                   [(ngModel)]="editableAuthorizations.banking"
                   (change)="onPermissionChange()">
            <span class="checkmark"></span>
            Banking
          </label>
          <label class="permission-item">
            <input type="checkbox" 
                   [(ngModel)]="editableAuthorizations.loans"
                   (change)="onPermissionChange()">
            <span class="checkmark"></span>
            Loans
          </label>
          <label class="permission-item">
            <input type="checkbox" 
                   [(ngModel)]="editableAuthorizations.tasks"
                   (change)="onPermissionChange()">
            <span class="checkmark"></span>
            Tasks
          </label>
        </div>
        <div class="permission-column">
          <label class="permission-item">
            <input type="checkbox" 
                   [(ngModel)]="editableAuthorizations.relatedParties"
                   (change)="onPermissionChange()">
            <span class="checkmark"></span>
            Related Parties
          </label>
          <label class="permission-item">
            <input type="checkbox" 
                   [(ngModel)]="editableAuthorizations.investments"
                   (change)="onPermissionChange()">
            <span class="checkmark"></span>
            Investments
          </label>
          <label class="permission-item">
            <input type="checkbox" 
                   [(ngModel)]="editableAuthorizations.documents"
                   (change)="onPermissionChange()">
            <span class="checkmark"></span>
            Documents
          </label>
          <label class="permission-item">
            <input type="checkbox" 
                   [(ngModel)]="editableAuthorizations.requests"
                   (change)="onPermissionChange()">
            <span class="checkmark"></span>
            Requests
          </label>
        </div>
      </div>
      
      <!-- Update Button for Permissions -->
      <div class="permissions-actions">
        <button class="update-btn btn-primary" 
                [disabled]="!hasPermissionsChanged() || isUpdating()"
                (click)="onUpdatePermissions()">
          @if (isUpdating()) {
          <span>Updating...</span>
          } @else {
          <span>Update Permissions</span>
          }
        </button>
      </div>
    </div>
    }

    <!-- User Actions Section -->
    <div class="user-actions-section">
      <h4>User Actions</h4>
      <p class="section-hint">Manage user account and send invites.</p>

      <!-- Simple Tabs -->
      <div class="action-tabs" role="tablist" aria-label="User actions">
        <button type="button"
                id="tab-manage"
                class="tab-btn"
                role="tab"
                [attr.aria-selected]="activeActionTab() === 'manage'"
                aria-controls="panel-manage"
                [class.active]="activeActionTab() === 'manage'"
                (click)="selectActionTab('manage')">Manage Account</button>
        <button type="button"
                id="tab-invite"
                class="tab-btn"
                role="tab"
                [attr.aria-selected]="activeActionTab() === 'invite'"
                aria-controls="panel-invite"
                [class.active]="activeActionTab() === 'invite'"
                (click)="selectActionTab('invite')">Send User Invite</button>
      </div>

      <!-- Combined Action Messages -->
      @if (combinedActionMessage()) {
      <div class="action-message success-message">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <span>{{ combinedActionMessage() }}</span>
      </div>
      }

      @if (combinedActionError()) {
      <div class="action-message error-message">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
        <span>{{ combinedActionError() }}</span>
      </div>
      }

      <!-- Manage Account Tab Content -->
      @if (activeActionTab() === 'manage') {
      <div id="panel-manage" class="action-buttons" role="tabpanel" [attr.aria-labelledby]="'tab-manage'">
        <!-- Show Activate button if user is inactive (status = 5), otherwise show Deactivate -->
        @if (userData?.status === 5) {
        <button class="action-btn activate" 
                [disabled]="isUpdating()"
                (click)="onActivateUser()">
          @if (isUpdating()) {
          <span>Activating...</span>
          } @else {
          <span>Activate User</span>
          }
        </button>
        } @else if (userData?.status !== 5) {
        <button class="action-btn deactivate" 
                [disabled]="isUpdating()"
                (click)="onDeactivateUser()">
          @if (isUpdating()) {
          <span>Deactivating...</span>
          } @else {
          <span>Deactivate User</span>
          }
        </button>
        }
        <button class="action-btn reset" 
                [disabled]="isResettingTerms()"
                (click)="onResetTermsConditions()">
          @if (isResettingTerms()) {
          <span>Resetting...</span>
          } @else {
          <span>Reset Terms & Conditions</span>
          }
        </button>
        <button class="action-btn delete" 
                [disabled]="isDeleting()"
                (click)="onDeleteUser()">
          @if (isDeleting()) {
          <span>Deleting...</span>
          } @else {
          <span>Delete User</span>
          }
        </button>
      </div>
      }

      <!-- Send User Invite Tab Content -->
      @if (activeActionTab() === 'invite') {
      <div id="panel-invite" role="tabpanel" [attr.aria-labelledby]="'tab-invite'">
        <div class="action-buttons">
          <button class="action-btn invite"
                  title="Sends an invite email using the configured application mailbox via Microsoft Graph"
                  [disabled]="isSendingInvite() || !userData?.email"
                  (click)="onSendEmail()">
            @if (isSendingInvite()) {
            <span>Sending...</span>
            } @else {
            <span>Send Invitation Email</span>
            }
          </button>
        </div>
      </div>
      }
    </div>

  </div>
</app-generic-modal>